import { type ReactElement } from "react";

import Icons from "assets";

/**
 * MUI's `AlertColor` plus the `inherit` augmentation in `src/types/mui.d.ts`, restated: `src/theme`
 * cannot import `@mui/material`.
 */
export type AlertSeverity = "success" | "info" | "warning" | "error" | "inherit";

export const ALERT_GLYPH = 24;

/**
 * Figma's glyphs are Material's at 24px. `CheckCircle` and `ExclamationCircle` are the same paths drawn
 * on a 20-unit grid, so they only need the box; `WarningIndicator` is the same triangle on a 25-wide
 * canvas, shifted 0.846 units right — the `viewBox` crops it back onto Figma's 24px box rather than
 * shrinking it by 24/25.
 */
export const ALERT_ICON_MAPPING: Record<AlertSeverity, ReactElement> = {
  success: <Icons.CheckCircle width={ALERT_GLYPH} height={ALERT_GLYPH} />,
  info: <Icons.InfoIndicator width={ALERT_GLYPH} height={ALERT_GLYPH} />,
  inherit: <Icons.InfoIndicator width={ALERT_GLYPH} height={ALERT_GLYPH} />,
  warning: (
    <Icons.WarningIndicator width={ALERT_GLYPH} height={ALERT_GLYPH} viewBox="0.846 0 24 24" />
  ),
  error: <Icons.ExclamationCircle width={ALERT_GLYPH} height={ALERT_GLYPH} />,
};
